import { AppConfigModel } from "../../abstract/app-config.model";

export class RecurringInvoiceEndingMode extends AppConfigModel {

    static override CLASS_NAME: string = 'RecurringInvoiceEndingMode';
}
